import { Route, Switch } from "react-router-dom";

import { PasswordResetRoute } from "../../routes/PasswordResetRoute";
import { Routes } from "../../types";
import { PasswordResetConfirmationRoute } from "../../routes/PasswordResetConfirmationRoute";

export const Router = () => {
  return (
    <Switch>
      <Route exact path={Routes.Default} component={PasswordResetRoute} />
      <Route exact path={Routes.PasswordReset} component={PasswordResetRoute} />
      <Route
        exact
        path={Routes.PasswordResetConfirmation}
        component={PasswordResetConfirmationRoute}
      />
    </Switch>
  );
};
